export * from "./CampaignLargeMobile";
